import { Component, OnInit, ElementRef, HostListener } from '@angular/core';

import { ApiConnectionService } from '../../services/core/api-connection.service';
import { AppService } from '../../services/app.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContentComponent } from '../../modals/modal-content/modal-content.component';

import { DomSanitizer } from '@angular/platform-browser';

import { interval } from "rxjs/internal/observable/interval";
import { repeat, startWith, switchMap } from "rxjs/operators";
import { ConfigService } from '../../services/core/config.service';

import { AuthenticationService } from '../../services/core/authentication.service';
import { ModalPdfComponent } from 'src/app/modals/modal-pdf/modal-pdf.component';
import { ModalAnswersOverviewComponent } from 'src/app/modals/modal-answers-overview/modal-answers-overview.component';
import { ModalPortfolioUploadComponent } from 'src/app/modals/modal-portfolio-upload/modal-portfolio-upload.component';
import { ModalPortfolioPreviewComponent } from 'src/app/modals/modal-portfolio-preview/modal-portfolio-preview.component';
import { ModalConfirmDeleteComponent } from 'src/app/modals/modal-confirm-delete/modal-confirm-delete.component';

@Component({
	selector: 'app-lesson-details',
	templateUrl: './lesson-details.component.html',
	styleUrls: ['./lesson-details.component.scss']
})
export class LessonDetailsComponent implements OnInit {
	item;
	chapter;
	currentUser;
	apiUrl = '';
	baseUrl = '';
	anchors;
	frontStyle;
	feedbackActive = false;
	feedbackDescription = "";
	feedbackError = '';
	feedbackSuccess = '';
	feedbackItems: any = [];
	checkRequestState = '';
	lessoncontent: any = '';
	lessonVideo: any = '';
	modal: any = '';
	lessonCount = 0;
	choiceAssignmentsCount = 0;
	termTabListActive = true;
	termTabCardsActive = false;
	termTabQuizActive = false;
	terms: any = [];
	navCollapsed = true;
	showLessonList = false;
	showOptionsMenu = false;
	showAnswersOverlayBox = false;
	classrooms: any = [];
	students: any = [];
	studyLevels: any = [];
	currentClassroom = '';
	currentStudent = '';
	answers: any = [];
	showCheckAnswers = true;
	showAnswerContainers = false;
	postQuestionStateTimeout;
	exerciseNumber = '';
	questionTitle = '';
	cdnUrl = ''
	systemTitle = ''
	systemSlogan = ''
	salesWebsite = '';
	systemKey = '';
	questionCssClassPrefix = '';
	previewId = '';
	currentStudentId = '';
	showSuggestedAnswerInModal = false;
	suggestedAnswer = '';
	choiceAssignmentTitle = '';
	questionIds: any = [];
	answersLoaded = false;

	shouldWrap = false;

	showStudentAnswerNames = false;

	letters: any = [];
	activeLetter = 'all';

	lessonId: string = '';
	questionsWithAnswers: any = [];
	currentQuestionId = '';
	currentQuestionPosition = -1;

	isChoiceAssignmentChapter = false;
	missingStudents: any = [];

	isContentPreview = false;
	triggeredContentPreviewModal = false;

	objKeys = Object.keys;

	constructor(
		private activatedRoute: ActivatedRoute,
		public appService: AppService,
		public apiConnectionService: ApiConnectionService,
		private route: ActivatedRoute,
		private modalService: NgbModal,
		private router: Router,
		private dom: DomSanitizer,
		private configService: ConfigService,
		private authenticationService: AuthenticationService,
		private ngxLoader: NgxUiLoaderService,
		private elementRef: ElementRef,
	) {
		let self = this;

		this.cdnUrl = configService.get('cdn_url');
		this.systemTitle = configService.get('title');
		this.systemSlogan = configService.get('slogan');
		this.salesWebsite = configService.get('sales_website');
		this.systemKey = configService.get('system_key');
		this.baseUrl = configService.get('front_url');
		this.frontStyle = configService.get("front_style");
		this.questionCssClassPrefix = configService.get('question_css_class_prefix');

		self.authenticationService.data.subscribe(data => {
			if (Object.keys(data).length) {
				self.currentUser = data;
				self.appService.getActivities(self.currentUser['id']);
				self.setClassrooms();
				this.isContentPreview = false;
			} else {
				self.currentUser = false;
				this.isContentPreview = true;
			}
		});

		if (this.route.snapshot.paramMap.get('previewId')) {
			this.previewId = this.route.snapshot.paramMap.get('previewId');
		}

		self.appService.activitiesData.subscribe(data => {
			try {
				let currentUrl = this.route.snapshot['_routerState'].url;
				for (let key in data['activities']['checkRequests']) {
					if (data['activities']['checkRequests'][key]['chapterLessonId'] === self.item['id']) {
						let oldState = self.checkRequestState;
						self.checkRequestState = data['activities']['checkRequests'][key]['checkStatus'];
						if (self.checkRequestState != oldState && self.checkRequestState == 'APPROVED' && data['activities']['checkRequests'][key]['dateStart'] == null) {
							if (currentUrl.includes(data['activities']['checkRequests'][key]['chapterLessonId']) && document.querySelectorAll('.btn-sm.methode-m-answer-button').length < 1) {
								// self.showCheckRequestApprovedModal(data['activities']['checkRequests'][key]);
								window.location.reload();
							}
						}
						return;
					}
				}
				self.checkRequestState = '';
			} catch (e) {

			}
		});

		this.apiUrl = self.configService.get('api_url');
		this.choiceAssignmentTitle = self.configService.get('choice_assignments_title');
		self.appService.hideCheckRequestAlert();
	}

	@HostListener('window:scroll', [])
	onWindowScroll() {
		const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

		if (scrollPosition > 1100 && this.isContentPreview && this.item['lesson']['free'] != 1 && !this.triggeredContentPreviewModal && !this.currentUser) {
			this.triggeredContentPreviewModal = true;
			this.showLogin(true);
		}
	}

	isPreview(): boolean {
		let status = (this.previewId != '' ? true : false);
		return status;
	}

	ngOnInit(): void {
		let self = this;

		/*
		* Clear feedback
		*/
		self.feedbackDescription = "";
		self.feedbackError = '';
		self.feedbackSuccess = '';

		this.appService.navInactive();
		this.route.params.subscribe(params => {
			try {
				if (params['id'] && params['studentId']) {
					self.showAnswerTextContainers();
				}
				self['modal'].close();
			} catch (e) {

			}

			self.feedbackDescription = "";
			self.feedbackError = '';
			self.feedbackSuccess = '';

			self.checkRequestState = '';
			window.scroll(0, 0);
			this.fetchItem();
		});

		this.currentStudentId = this.route.snapshot.paramMap.get('studentId');

		this.setStudyLevels();

		//detect router changes and setup portfolio boxes
		this.route.params.subscribe(params => {
			setTimeout(() => {
				// this.setDOMHandlers()
			}, 2000);
		});

		this.shouldScrollToPortfolioItem()
	}

	async shouldScrollToPortfolioItem() {
		const url = new URL(location.href)
		if (!url.searchParams.get('editportfolio')) {
			return
		}
		await this.awaitLessonLoaded()
		const firstPortfolioItem = document.querySelectorAll('.portfolio-bewijs,.portfolio-reflectie')[0]
		firstPortfolioItem.scrollIntoView()
		window.scrollTo({ top: firstPortfolioItem.getBoundingClientRect().top + window.scrollY + -250, behavior: 'smooth' })
	}

	openModule() {
		if (this.frontStyle == "sections") {
			if (this.item['chapter']['layout'] === "OVERVIEW") {
				open('/module/' + this.item.chapter.slug, "_self");
			} else {
				open('/elective/' + this.item.chapter.sectionId, "_self");
			}
		} else if (this.frontStyle == "method") {
			open('/', "_self");
		} else {
			if (this.item['chapter']['layout'] === "FIRST_LESSON") {
				open('/', "_self");
			} else {
				open('/module/' + this.item.chapter.slug, "_self");
			}
		}
	}

	setupExternalRedirects() {
		const hrefs = document.getElementsByTagName("a");

		for (let i = 0; i < hrefs.length; i++) {
			const url = hrefs[i].href;

			if (!url.includes("methodem") && !url.includes("studiobx") && !url.includes("javascript:;")) {
				hrefs[i].target = "_blank";
			}
		}
	}

	setDOMHandlers(): void {
		let self = this;
		this.answersLoaded = false;
		setTimeout(function () {
			self.showAnswerTextContainersForStudents();
			setTimeout(function () {
				self.postUserAnswerInput();
			}, 2000);

			self.addClickListenerToAnswerButtons();
			self.addShowStudentAnswersButtons();
			window['checkLessonTextareas']();

			//setup teacher block
			const teacherBlocks = document.getElementsByClassName("docenten");

			for (let i = 0; i < teacherBlocks.length; i++) {
				const button = teacherBlocks[i].getElementsByClassName("hideTeacherBlock")[0];

				button.addEventListener("click", function () {
					const classList = teacherBlocks[i].classList;

					if (classList.contains("hidden")) {
						classList.remove("hidden");
					} else {
						classList.add("hidden");
					}
				});
			}

			self.setupExternalRedirects();
		}, 1000);

		if (this.currentStudentId == '' || this.currentStudentId == null) {
			this.handlePortfolioInput();
		} else {
			setTimeout(() => {
				this.blockInputFields();
			}, 2000);
		}
	}

	scrollTop() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}

	ngOnDestroy(): void {
		try {
			self['modal'].close();
		} catch (e) {

		}
		try {
			window['resetSidebar']();
		} catch (e) {

		}
	}

	getRouter() {
		return this.router;
	}

	showCheckRequestApprovedModal(checkRequest) {
		let self = this;

		this.modal = this.modalService.open(ModalContentComponent, {
			backdrop: 'static',
			keyboard: false
		});

		this.modal.componentInstance.message = 'Joe! Je kunt gaan nakijken!';
		this.modal.componentInstance.title = 'Wakker worden!';
		this.modal.componentInstance.button = 'Okee!';
		this.modal.result.then((result) => {
			if (result) {
				self.ngxLoader.start();
				this.apiConnectionService.read('checkRequests/start/' + checkRequest.checkRequestId + '',).then((response) => {
					window.location.hash = '';
					window.location.reload();
					self.ngxLoader.stop();
				});
			}
		});
	}

	splitAlternativeString(str) {
		return str.replace(/,/g, ", ");
	}

	showDownloadPdf() {
		let self = this;

		let modalContent = 'Bezig met genereren van pdf .... '

		this.modal = this.modalService.open(ModalPdfComponent, {
			backdrop: 'static',
			keyboard: false
		});

		this.modal.componentInstance.title = 'PDF';
		this.modal.componentInstance.chapterLesson = self.item;

		if (this.currentStudentId) {
			this.modal.componentInstance.currentStudentId = self.currentStudentId;
		} else {
			this.modal.componentInstance.currentStudentId = "";
		}

		this.modal.componentInstance.button = 'Download PDF';
		this.modal.componentInstance.message = modalContent
	}

	showNoAnswerMessage() {
		let self = this;
		this.modal = this.modalService.open(ModalContentComponent, {
			backdrop: 'static',
			keyboard: false
		});

		this.answersLoaded = false;

		this.modal.componentInstance.title = 'Geen antwoorden';
		this.modal.componentInstance.message = 'Leerlingen hebben in deze les op niveau ' + self.currentClassroom['defaultStudyLevel'] + ' nog geen opdrachten gemaakt.';
		this.modal.result.then((result) => {
			if (result) {

			}
		});
	}

	showAnswerModal() {
		this.answersLoaded = true;

		let self = this;

		this.apiConnectionService.read('answers/overview/' + self.item['lesson']['id'] + "/" + this.currentUser['currentClassroomId']).then((response) => {

			if (response['hasAnswers'] === false) {
				self.showNoAnswerMessage();
				return;
			}

			this.modal = this.modalService.open(ModalAnswersOverviewComponent, {
				backdrop: 'static',
				keyboard: false,
				windowClass: 'answersOverview',
				backdropClass: 'answersOverviewBackup'
			});

			this.modal.componentInstance.answerData = response;

			this.modal.componentInstance.title = this.item['lesson']['name'];
			this.modal.componentInstance.chapterLesson = self.item;
			this.modal.componentInstance.classroomId = this.currentUser['currentClassroomId'];
			this.modal.componentInstance.questionIds = this.questionIds;

			this.answersLoaded = false;
		});

	}

	video(videoHTML) {
		return this.dom.bypassSecurityTrustHtml(videoHTML);
	}

	backgroundColor(color) {
		return this.dom.bypassSecurityTrustHtml('<style> body { background-color: ' + color + '; }</style>');
	}

	text(lesson) {
		return this.dom.bypassSecurityTrustHtml(lesson);
	}

	getLessons(page, choiceAssignments = false) {
		// Create array for the regular lessons list
		let lessons = this.item['chapter']['lessons'].filter(
			function (lesson) {
				if (lesson['type'] != null) {
					return lesson['type'].toLowerCase() === 'lesson' || lesson['type'].toLowerCase() === 'terms';
				}
			}
		);

		// Create array for the choice assignments list
		if (choiceAssignments) {
			lessons = this.item['chapter']['lessons'].filter(
				function (lesson) {
					if (lesson['type'] != null) {
						return lesson['type'].toLowerCase() === 'choice_assignment';
					}
				}
			);
		}

		if (lessons.length > 5) {
			let count = Math.ceil(lessons.length / 2);
			let start = ((page - 1) * count);
			lessons = lessons.slice(start, start + (page * count));
		}
		if (lessons.length > 10) {
			this.shouldWrap = true;
		}
		return lessons;
	}

	getPartialLessons(page, choiceAssignments) {
		if (this.item) {
			// Create array for the regular lessons list
			let lessons = this.item['chapter']['lessons'].filter(
				function (lesson) {
					if (lesson['type'] != null) {
						return lesson['type'].toLowerCase() === 'lesson' || lesson['type'].toLowerCase() === 'terms';
					}
				}
			);

			// Create array for the choice assignments list
			if (choiceAssignments) {
				lessons = this.item['chapter']['lessons'].filter(
					function (lesson) {
						if (lesson['type'] != null) {
							return lesson['type'].toLowerCase() === 'choice_assignment';
						}
					}
				);
			}

			let partialLessons = [];
			const startIndex = (page * 6);
			for (let i = startIndex; i < (startIndex + 6); i++) {
				if (lessons[i] != undefined) {
					partialLessons.push(lessons[i]);
				}
			}
			return partialLessons;
		}
	}

	truncateText(text: string, maxLength: number): string {
		if (text.length <= maxLength) {
			return text;
		} else {
			return text.slice(0, maxLength) + '.';
		}
	}

	toTop() {
		(window as any).scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	fetchItem() {
		let self = this;

		self.lessonCount = 0;
		self.choiceAssignmentsCount = 0;

		let studentId = this.route.snapshot.paramMap.get('studentId');
		if (!studentId || studentId == null) {
			studentId = '';
		}

		let id = this.route.snapshot.paramMap.get('id');

		let url = 'chapterLessons/detail/' + id + '/' + studentId + '';
		if (this.isPreview() == true) {
			self.showAnswerContainers = false;
			url = 'chapterLessons/preview/' + this.previewId + '';
		}

		this.authenticationService.getCurrentUser().then(function (data) {
		}).catch(function (data) {
		});

		this.apiConnectionService.read(url).then((response) => {
			self.item = response;
			self.isChoiceAssignmentChapter = self.item['chapter']['hasChoiceAssignment'];

			self.lessonVideo = self.dom.bypassSecurityTrustHtml(response['lesson']['videoFrame']);
			self.lessoncontent = self.dom.bypassSecurityTrustHtml(response['lesson']['studyLevelContent']);

			self.appService.setCurrentAuthor(response['lesson']['author']);
			self.appService.getActivities(self.currentUser['id']);

			self.ngxLoader.stop();

			let collection: any = response;
			for (let key in collection['chapter']['lessons']) {
				if (collection['chapter']['lessons'][key]['type'] == 'LESSON')
					self.lessonCount++;

				if (collection['chapter']['lessons'][key]['type'] == 'CHOICE_ASSIGNMENT')
					self.choiceAssignmentsCount++;
			}

			if (self.item['lesson']['type'] == 'TERMS') {
				self.getChapterTerms();
			}

			self.appService.setPageTitle('' + self.item['lesson']['name'] + ' - ' + self.item['chapter']['name'] + '');
			self.appService.setPageDescription(self['item']['lesson']['description']);

			self.lessonId = response['lesson']['id'];

			self.setDOMHandlers();

		}).catch(function () {
			self.router.navigate(['/not-found']);
			self.ngxLoader.stop();
		});
	}

	toggleFeedback() {
		if (this.feedbackActive === false) {
			this.feedbackSuccess = '';
			this.feedbackDescription = '';
			this.feedbackActive = true;
		} else {
			this.feedbackActive = false;
		}
	}

	getChapterTerms() {
		let self = this;

		let letters = {};

		let path = 'terms/chapter/' + this.item['chapter']['id'] + '';

		let studentId = this.route.snapshot.paramMap.get('studentId');

		if (studentId && studentId != '') {
			path = 'terms/chapter/' + this.item['chapter']['id'] + '/' + studentId;
		}

		this.apiConnectionService.read(path).then((response) => {
			self.terms = response;

			for (let key in self.terms) {
				letters[self.terms[key]['letter']] = 1;
			}

			self.letters = Object.keys(letters);
		});
	}

	sendFeedback() {
		let self = this;

		if (!this.feedbackDescription) {
			self.ngxLoader.stop();
			self.feedbackError = 'Je hebt helemaal niets ingevuld?!';
		} else {
			this.ngxLoader.start();
			this.apiConnectionService.save('lessonFeedbacks/add', { lessonId: self.item.lesson.id, content: this.feedbackDescription }).then((response) => {
				self.ngxLoader.stop();
				self.feedbackActive = false;
				self.feedbackError = '';
				self.feedbackSuccess = 'Bedankt voor je feedback! We gaan ernaar kijken.';
			}).catch(function () {
				self.ngxLoader.stop();
			});
		}

	}

	setActiveLetter(letter) {
		this.activeLetter = letter;
	}

	showLogin(isPreview = false) {
		this.appService.showLoginModal(isPreview);
	}

	changeTermTab(tabName) {
		if (tabName === 'cards') {
			this.termTabListActive = false;
			this.termTabCardsActive = true;
			this.termTabQuizActive = false;
		} else if (tabName === 'quiz') {
			this.termTabListActive = false;
			this.termTabCardsActive = false;
			this.termTabQuizActive = true;
		} else {
			this.termTabListActive = true;
			this.termTabCardsActive = false;
			this.termTabQuizActive = false;
		}
	}

	sendCheckRequest() {
		let self = this;

		self.checkRequestState = 'PROCESSING';

		this.ngxLoader.start();
		this.apiConnectionService.read('checkRequests/add/' + this.item['id'] + '').then((response) => {
			self.ngxLoader.stop();
			self.checkRequestState = 'WAITING';
		});
	}

	toggleNavCollapsed() {
		this.navCollapsed = !this.navCollapsed;
	}

	closeAnswersOverlayBox() {
		this.showAnswersOverlayBox = false;
		this.showSuggestedAnswerInModal = false;
		document.querySelector('body').style.overflowY = "auto";
	}

	checkUserAnswerButtons() {
		let answerContainers = this.elementRef.nativeElement.querySelectorAll('.methode-m-answer-text-container');
		for (let i = 0; i < answerContainers.length; i++) {
			let answerContainer = answerContainers[i];
			let textarea = answerContainer.querySelector('textarea');

			let buttonContainers = answerContainers[i].querySelectorAll('.answer-buttons');
			for (let x = 0; x < buttonContainers.length; x++) {
				try {
					let buttonContainer = buttonContainers[x];
					if (textarea.value === '') {
						buttonContainer.classList.add("d-none");
					}
					else {
						buttonContainer.classList.remove("d-none");
					}
				} catch (e) {
					console.log('Geen textarea gevonden');
				}
			}
		}
	}

	awaitLessonLoaded() {
		return new Promise((resolve, reject) => {
			const callback = (mutations) => {
				mutations.forEach(mutation => {
					if (!mutation.addedNodes) return;
					for (let node of mutation.addedNodes) {
						if (node.classList && node.classList.contains('bg-lesson')) {
							observer.disconnect();
							resolve(true);
						}
						if (node.classList && node.classList.contains('lesson-title')) {
							observer.disconnect();
							resolve(true);
						}
					}
				});
			}
			const observer = new MutationObserver(callback);

			const config = { attributes: true, childList: true, subtree: true, characterData: false };
			observer.observe(document.querySelector('body .lesson'), config);
		});
	}

	blockInputFields() {
		const portfolioReflectionInputs = document.querySelectorAll('.portfolio-reflectie textarea');
		const portfolioProveInputs = document.querySelectorAll('.portfolio-bewijs input[type="file"]');
		const textarea = document.querySelectorAll('textarea');
		const portfolioFile = document.querySelectorAll('.portfolio-file');

		portfolioReflectionInputs.forEach((item: any) => {
			item.style.pointerEvents = "none";
		});

		portfolioProveInputs.forEach((item: any) => {
			item.style.pointerEvents = "none";
		});

		textarea.forEach((item: any) => {
			item.style.pointerEvents = "none";
		});

		portfolioFile.forEach((item: any) => {
			item.style.pointerEvents = "none";
		});
	}

	async handlePortfolioInput() {
		let self = this;
		await this.awaitLessonLoaded();
		const portfolioReflectionInputs = document.querySelectorAll('.portfolio-reflectie textarea');
		portfolioReflectionInputs.forEach(input => {
			let submitDelay;
			input.addEventListener('keyup', function (event) {
				const target = event.target as HTMLInputElement;
				if (!target.value) return;
				self.portfolioInputStatusMessage(input, 'Opslaan...');
				clearTimeout(submitDelay);
				submitDelay = setTimeout(() => {
					const value = target.value;

					const dataset = target.parentElement.parentElement.dataset;

					const key = dataset.key;
					const lessonId = dataset.portfolioLessonId;
					const chapterId = dataset.portfolioChapterId;
					const position = dataset.position;
					const lessonContentId = dataset.lessonContentId;

					const title = dataset.title;

					const index = target.dataset.index;

					self.portfolioInputStatusMessage(input, '');

					const description = target.dataset.title;

					self.postPortfolioReflection(key, lessonId, chapterId, position, title, value, index, lessonContentId, description);
				}, 2000);
			});
		});

		const portfolioProveInputs = document.querySelectorAll('.portfolio-bewijs input[type="file"]');
		portfolioProveInputs.forEach(input => {
			input.addEventListener('change', async function (event) {
				const target = event.target as HTMLInputElement;

				if (!target.files[0].type.startsWith('image/')) {
					self.portfolioInputStatusMessage(input, 'Alleen afbeeldingen zijn toegestaan...');
					return;
				}

				const dataset = target.parentElement.parentElement.parentElement.dataset;

				const key = dataset.key;
				const lessonId = dataset.portfolioLessonId;
				const chapterId = dataset.portfolioChapterId;
				const position = dataset.position;
				const fileIndex = target.getAttribute("name");
				const description = dataset.intro;
				const lessonContentId = dataset.lessonContentId;

				const reader = new FileReader();
				reader.readAsDataURL(target.files[0]);
				reader.onload = () => {
					const modal = self.modalService.open(ModalPortfolioUploadComponent, {
						backdrop: 'static',
						keyboard: false
					});

					modal.componentInstance.imageChangedEvent = event;

					modal.componentInstance.croppedImage.subscribe((base64) => {
						self.postPortfolioImage(key, lessonId, chapterId, position, fileIndex, description, base64, input, lessonContentId);
					});
				}
			});

			const portfolioName = input.getAttribute("name");
			const imageContainer = document.getElementById(portfolioName.replace("file", "image"));
			const removeButton = input.parentElement.querySelector('span.remove-portfolio');

			this.setupPortfolioImagePreview(removeButton, input);
			this.setupPortfolioContainerSizes();
		});

		const portfolioReflectionItem = document.querySelectorAll('.portfolio-reflectie .portfolio-reflectie-item')
		const MAX_LENGTH = 200
		portfolioReflectionItem.forEach(reflection => {
			let characterLimitTimout
			reflection.addEventListener('input', () => {
				const textarea = reflection.querySelector('textarea');
				textarea.value = textarea.value.substring(0, MAX_LENGTH);

				if (!reflection.querySelector('.character-limit')) {
					const characterLimitText = document.createElement('span')
					characterLimitText.classList.add('character-limit')
					reflection.append(characterLimitText)
				}
				reflection.querySelector('.character-limit').textContent = textarea.value.length + ' / 200'

				clearTimeout(characterLimitTimout)
				characterLimitTimout = setTimeout(() => {
					reflection.querySelector('.character-limit').remove()
				}, 5000);
			});
		});

		const portfolioBlocks = document.querySelectorAll('.portfolio-reflectie, .portfolio-bewijs');
		portfolioBlocks.forEach((portfolioBlock: HTMLElement) => {
			const buttons = portfolioBlock.querySelectorAll('.portfolio-submit-container button');
			buttons.forEach(button => {
				button.addEventListener('click', (e) => {
					e.preventDefault()

					const target = e.target as HTMLElement
					const portfolioKey = portfolioBlock.dataset.key
					const lessonId = portfolioBlock.dataset.portfolioLessonId

					if (!this.canSubmitPortfolio(portfolioKey)) {
						// return;
					}

					const status = target.classList.contains('submitted') ? 'UNSUBMITTED' : 'SUBMITTED'
					let data = {
						userId: '',
						lessonId: lessonId,
						portfolioKey: portfolioKey,
						status: status
					}

					let studentId = this.route.snapshot.paramMap.get('studentId');
					if (!studentId || studentId == '') {
						data['userId'] = this.currentUser['id'];
					} else {
						data['userId'] = studentId;
					}

					button.classList.add('loading')
					this.apiConnectionService.save('users/portfolioSubmit', data).then(response => {
						button.classList.remove('loading')
						if (status == 'SUBMITTED') {
							portfolioBlock.querySelector('.portfolio-submit-container').classList.add('is-submitted')
							const submitDate = portfolioBlock.querySelector('.portfolio-submit-container span.submitted-date')
							if (!submitDate.innerHTML) {
								submitDate.innerHTML = this.formatDate(new Date)
							}
						} else {
							portfolioBlock.querySelector('.portfolio-submit-container').classList.remove('is-submitted')
							const submitDate = portfolioBlock.querySelector('.portfolio-submit-container span.submitted-date')
							submitDate.innerHTML = ''
						}
					}).catch(function (e) {

						let modal = self.modalService.open(ModalContentComponent, {
							backdrop: 'static',
							keyboard: false
						});
						let message = e.error.messsage;

						modal.componentInstance.message = '' + message + '';
						modal.componentInstance.title = 'Inleveren';
						modal.componentInstance.button = 'Sluiten';
						modal.result.then((result) => {
							button.classList.remove('loading')
						});
					});
				})
			})
		})
	}

	canSubmitPortfolio(portfolioKey) {
		let canSubmit = false

		const portfolioBlock = document.querySelector('div[data-key="' + portfolioKey + '"]');

		if (portfolioBlock.classList.contains('portfolio-bewijs')) {
			let hasFilledImage = false;

			const images = portfolioBlock.querySelectorAll('.portfolio-file img');
			images.forEach(image => {
				if (image.getAttribute('src') != '') {
					hasFilledImage = true;
				}
			})

			if (hasFilledImage) {
				canSubmit = true
			}
		} else if (portfolioBlock.classList.contains('portfolio-reflectie')) {
			let hasFilledTextarea = false;

			const textareas = portfolioBlock.querySelectorAll('textarea');
			textareas.forEach(textarea => {
				if (textarea.value != '') {
					hasFilledTextarea = true;
				}
			})

			if (hasFilledTextarea) {
				canSubmit = true
			}
		}

		return canSubmit
	}

	formatDate(datetimeStr) {
		const months = ["januari", "februari", "maart", "april", "mei", "juni",
			"juli", "augustus", "september", "oktober", "november", "december"];

		const dateObj = new Date(datetimeStr);
		const day = dateObj.getDate();
		const monthIndex = dateObj.getMonth();
		const year = dateObj.getFullYear();

		const formattedDate = `${day} ${months[monthIndex]} ${year}`;

		return formattedDate;
	}

	async setupPortfolioImagePreview(elem, input) {
		const self = this;

		elem.addEventListener('click', async function (e) {
			let inputId = input.id;
			let portfolioBlockKey = inputId.replace(/-file-\d+/, '');
			portfolioBlockKey = portfolioBlockKey.replace('portfolio-', '');

			const modal = self.modalService.open(ModalConfirmDeleteComponent, {
				backdrop: 'static',
				keyboard: false
			});

			modal.componentInstance.message = 'Weet je zeker dat je de afbeelding wil verwijderen?';

			modal.componentInstance.passEntry.subscribe((shouldDelete) => {
				if (!shouldDelete) {
					return
				}
				const fileId = elem.parentElement.querySelector('img').dataset.fileId

				self.apiConnectionService.save('users/removePortfolioFile/' + fileId, {}).then((response) => {
					elem.parentElement.querySelector('img').src = ''
					elem.parentElement.querySelector('img').classList.remove('imagePreview')
					setTimeout(() => {
						self.setupPortfolioContainerSizes();
						self.portfolioInputStatusMessage(elem, 'De afbeelding is verwijderd');
						self.removeSubmitState(portfolioBlockKey);
						setTimeout(() => {
							self.portfolioInputStatusMessage(elem, '');
						}, 5000);
					}, 50);
				}).catch(function (e) {
				});
			});
		});
	}

	setupPortfolioContainerSizes() {
		const fileContainers = document.querySelectorAll('.files');

		fileContainers.forEach(container => {
			const portfolioFiles = container.querySelectorAll('.portfolio-file');
			let bigClassAssigned = false;

			portfolioFiles.forEach((file, index) => {
				const img = file.querySelector('img');
				const srcFilled = img && img.getAttribute('src').trim() !== '';

				if (srcFilled) {
					file.classList.add('filled');
				} else {
					file.classList.remove('filled');
				}

				if (index > 0) {
					const prevFile = portfolioFiles[index - 1];
					const prevImg = prevFile.querySelector('img');
					const prevSrcFilled = prevImg && prevImg.getAttribute('src').trim() !== '';

					if (!prevSrcFilled) {
						file.classList.add('tiny');
					} else {
						file.classList.remove('tiny');
					}
				}

				if (!bigClassAssigned) {
					const parentHasFilledImg = Array.from(file.parentElement.querySelectorAll('.portfolio-file'))
						.some((sibling) => {
							const siblingImg = sibling.querySelector('img');
							return siblingImg && siblingImg.getAttribute('src').trim() !== '';
						});

					if (!parentHasFilledImg) {
						file.classList.add('big');
						bigClassAssigned = true;
					} else {
						file.classList.remove('big');
					}
				}
			});
		});
	}

	removeSubmitState(key) {
		try {
			const element = document.querySelector('[id="' + key + '-button-container"]');
			if (element) {
				element.classList.remove('is-submitted');
			}
		} catch (e) {

		}
	}

	async postPortfolioReflection(key, lessonId, chapterId, position, intro, value, portfolioIndex, lessonContentId, title) {
		let self = this;
		let answerData = {
			userId: '',
			portfolioKey: key,
			content: value,
			"position": position,
			"chapterId": chapterId,
			"lessonId": lessonId,
			"portfolioDescription": intro,
			"questionTitle": title,
			portfolioIndex: portfolioIndex,
			"lessonContentId": lessonContentId
		}

		let studentId = this.route.snapshot.paramMap.get('studentId');
		if (!studentId || studentId == '') {
			answerData['userId'] = this.currentUser['id'];
		} else {
			answerData['userId'] = studentId;
		}

		this.apiConnectionService.save('users/portfolio-reflection', answerData).then((response) => {
			self.removeSubmitState(key);
		}).catch(function (e) {
			self.removeSubmitState(key);
		});
	}

	async postPortfolioImage(key, lessonId, chapterId, position, fileIndex, description, value, element, lessonContentId) {
		const fileContainer = element.parentElement;

		const previewElem = document.createElement('img');
		previewElem.src = value;
		previewElem.classList.add("imagePreview");

		element.after(previewElem);
		fileContainer.classList.add("loading");

		let self = this;
		let answerData = {
			userId: '',
			portfolioKey: key,
			content: value,
			"position": position,
			"chapterId": chapterId,
			"lessonId": lessonId,
			"fileIndex": fileIndex,
			"portfolioDescription": description,
			"lessonContentId": lessonContentId
		}

		let studentId = this.route.snapshot.paramMap.get('studentId');
		if (!studentId || studentId == '') {
			answerData['userId'] = this.currentUser['id'];
		} else {
			answerData['userId'] = studentId;
		}

		this.apiConnectionService.save('users/portfolio-file', answerData).then((response) => {
			const fileId = (response as { id: string }).id
			previewElem.dataset.fileId = fileId

			fileContainer.classList.remove("loading");
			self.setupPortfolioImagePreview(previewElem, element);
			this.setupPortfolioContainerSizes();
			self.removeSubmitState(key);
		}).catch(function (e) {
			//TODO: replace above code with below
			fileContainer.classList.remove("loading");
			previewElem.remove();
			self.portfolioInputStatusMessage(element, 'Er is iets fout gegaan tijdens het opslaan...');
		});
	}

	portfolioInputStatusMessage(element, statusMessage) {
		let portfolioMessage = element.parentElement.querySelector('.status-message');
		if (!portfolioMessage) {
			const messageElem = document.createElement('div');
			messageElem.classList.add('status-message');
			messageElem.style.fontSize = '12px';
			messageElem.style.color = "#ff4a4a";
			element.after(messageElem);
			portfolioMessage = messageElem;
		}
		if (statusMessage.includes('Opslaan')) {
			statusMessage = '<i class="fa-solid fa-spinner mr-2"></i>' + statusMessage
		}
		portfolioMessage.innerHTML = statusMessage;
	}

	postUserAnswerInput() {
		try {
			let self = this;
			let answerData = {
				userId: '',
				questionId: '',
				content: ''
			}

			let studentId = this.route.snapshot.paramMap.get('studentId');
			if (!studentId || studentId == '') {
				answerData['userId'] = this.currentUser['id'];
			} else {
				answerData['userId'] = studentId;
			}

			if (self.isPreview() == true) {
				return false;
			}

			let userInputs = this.elementRef.nativeElement.querySelectorAll('.' + this.questionCssClassPrefix + 'text-answer');
			let timeout;

			if (userInputs != null) {

				for (let i = 0; i < userInputs.length; i++) {
					let question = userInputs[i].closest('.' + this.questionCssClassPrefix + 'question-container');
					let warningPopup = question.querySelector('.answer-loader');
					let loader = question.querySelector('.answer-loader2');

					userInputs[i].addEventListener('keyup', function () {
						let answerInput = this;
						let questionId = userInputs[i].getAttribute('data-question-id');
						answerData['questionId'] = questionId;
						try {
							self.checkUserAnswerButtons();
						} catch (e) {

						}
						clearTimeout(timeout);
						timeout = setTimeout(
							function () {
								if (userInputs[i].value.length != 0) {
									answerData['content'] = userInputs[i].value;
									self.showAnswerLoader(warningPopup, loader, answerData['content']);

									self.apiConnectionService.save('users/answer', answerData).then((response) => {
										self.changeStatusAnswerLoader(loader);
										self.hideAnswerLoader(loader);
									}).catch(function (e) {
										try {
											loader.style.opacity = '0';
											loader.querySelector('.answer-loader-icon2').classList.remove('fa-check');
										} catch (e) {

										}
										self.showErrorPopup(warningPopup, "Opslaan mislukt. Mogelijk heb je geen internet?");
									});
								}
							},
							2000);
					});

					userInputs[i].addEventListener('blur', function () {
						let questionId = userInputs[i].getAttribute('data-question-id');
						answerData['questionId'] = questionId;

						setTimeout(
							function () {
								const content = userInputs[i].value;
								answerData['content'] = content;

								if (content.length != 0) {
									self.showAnswerLoader(warningPopup, loader, answerData['content']);

									self.apiConnectionService.save('users/answer', answerData).then((response) => {
										self.changeStatusAnswerLoader(loader);
										// self.hideAnswerLoader(warningPopup);
									}).catch(function (e) {
										// self.hideAnswerLoader(warningPopup);
									});
								}
							},
							1);
					});

					self.checkUserAnswerButtons();
				}
			}
		} catch (err) {
		}
	}

	highlightAndPostAnswerState(buttons, state) {
		let self = this;
		let answerData = {
			userId: '',
			questionId: '',
			questionStatus: state
		}

		if (self.isPreview() == true) {
			return false;
		}

		let studentId = this.route.snapshot.paramMap.get('studentId');
		if (studentId == null) {
			answerData['userId'] = this.currentUser['id'];
		} else {
			answerData['userId'] = studentId;
		}

		if (buttons != null) {

			for (let i = 0; i < buttons.length; i++) {

				buttons[i].addEventListener('click', function () {
					let currentButton = buttons[i];
					let questionId = currentButton.getAttribute('data-question-id');
					answerData['questionId'] = questionId;
					let parent = currentButton.parentElement;
					let childs = parent.querySelectorAll('button');

					for (let j = 0; j < childs.length; j++) {
						if (childs[j] !== currentButton) {
							if (childs[j].classList.contains('highlight-perfect')) {
								childs[j].classList.remove('highlight-perfect');
							} else if (childs[j].classList.contains('highlight-correct')) {
								childs[j].classList.remove('highlight-correct');
							} else if (childs[j].classList.contains('highlight-wrong')) {
								childs[j].classList.remove('highlight-wrong');
							}
						}
					}

					switch (state) {
						case 'perfect':
							currentButton.classList.toggle('highlight');
							currentButton.classList.toggle('highlight-perfect');
							break;
						case 'correct':
							currentButton.classList.toggle('highlight');
							currentButton.classList.toggle('highlight-correct');
							break;
						case 'wrong':
							currentButton.classList.toggle('highlight');
							currentButton.classList.toggle('highlight-wrong');
							break;
					}

					if (currentButton.classList.contains('highlight')) {
						if (self.postQuestionStateTimeout) {
							clearTimeout(self.postQuestionStateTimeout);
						}

						let questionTextarea = self.elementRef.nativeElement.querySelector('.textarea-question-' + answerData['questionId'] + '');
						if (questionTextarea.classList.contains('border-left-perfect')) {
							questionTextarea.classList.remove('border-left-perfect');
						}
						if (questionTextarea.classList.contains('border-left-correct')) {
							questionTextarea.classList.remove('border-left-correct');
						}
						if (questionTextarea.classList.contains('border-left-wrong')) {
							questionTextarea.classList.remove('border-left-wrong');
						}
						questionTextarea.classList.add('border-left-' + answerData['questionStatus'] + '');

						self.postQuestionStateTimeout = setTimeout(
							function () {
								self.apiConnectionService.save('users/answer/status', answerData).then((response) => {
									let questionTextarea = self.elementRef.nativeElement.querySelector('.textarea-question-' + answerData['questionId'] + '');
									questionTextarea.classList.add('border-left-' + answerData['questionStatus'] + '');
								}).catch(function (e) {
								});
							},
							500);
					}

				});
			}
		}
	}

	addClickListenerToAnswerButtons() {
		try {
			let perfectButtons = this.elementRef.nativeElement.querySelectorAll('button[data-value="PERFECT"]');
			let correctButtons = this.elementRef.nativeElement.querySelectorAll('button[data-value="CORRECT"]');
			let wrongButtons = this.elementRef.nativeElement.querySelectorAll('button[data-value="WRONG"]');

			this.highlightAndPostAnswerState(perfectButtons, 'perfect');
			this.highlightAndPostAnswerState(correctButtons, 'correct');
			this.highlightAndPostAnswerState(wrongButtons, 'wrong');
		} catch (err) {
		}
	}

	toggleLessonList() {
		this.showLessonList = !this.showLessonList;
	}

	toggleOptionsMenu() {
		this.showOptionsMenu = !this.showOptionsMenu;
	}

	setClassrooms() {
		if (this.currentUser['role'] === 'TEACHER' || this.currentUser['role'] === 'EDITOR' || this.currentUser['role'] === 'ADMIN') {
			let self = this;
			this.ngxLoader.start();
			self.apiConnectionService.read('classrooms/school').then(function (response) {
				self.classrooms = response;
				self.sortClassroomsByMainTeacher();

				self.ngxLoader.stop();

				let classroomId = self.currentUser['currentClassroomId'];

				self.currentClassroom = self.classrooms.find(classroom => classroom['id'] === classroomId);
				self.setStudents(classroomId);
			});
		}
	}

	sortClassroomsByMainTeacher() {
		const teacherId = this.currentUser.id;

		this.classrooms = this.classrooms.sort((a, b) => {
			if (a.mainTeacherId === teacherId && b.mainTeacherId !== teacherId) {
				return -1;
			} else if (a.mainTeacherId !== teacherId && b.mainTeacherId === teacherId) {
				return 1;
			} else {
				return 0;
			}
		});
	}

	setCurrentClassroom(classroomId) {
		let self = this;
		this.apiConnectionService.read('users/setCurrentClassroomId/' + classroomId + '').then(function (response) {
			self.currentClassroom = self.classrooms.find(classroom => classroom['id'] === classroomId);
			self.setStudents(classroomId);

			self.ngxLoader.start();
			self.authenticationService.getCurrentUser().then(function (response) {
				self.fetchItem();
				self.ngxLoader.stop();
				self.goToStudentAnswers('no-student');
			});

		});
	}

	goToStudentAnswers(studentId) {
		if (studentId === 'no-student') {
			this.router.navigate(['/les/' + this.item['id'] + '']);
		} else {
			if (studentId == this.currentStudent['id']) {
				window.location.reload();
			}
			this.currentStudent = this.students.find(student => student['id'] === studentId);
			if (this.item != null && this.currentStudent != null) {
				this.currentStudentId = this.currentStudent['id'];
				this.router.navigate(['/les/' + this.item['id'] + '/' + this.currentStudent['id'] + '']);
			}
		}
		this.showOptionsMenu = false;
	}

	setStudents(classroomId) {
		let self = this;
		self.apiConnectionService.read('classrooms/students/' + classroomId + '').then(function (response) {
			self.students = response;
			self.ngxLoader.stop();
			self.setCurrentStudent(self.activatedRoute.snapshot.paramMap.get('studentId'));
		});
	}

	setCurrentStudent(studentId) {
		this.currentStudent = '';

		if (this.students.find(student => student['id'] === studentId) != null) {
			this.currentStudent = this.students.find(student => student['id'] === studentId);
		}
	}

	toggleShowAnswersOverlayBox(questionId, exerciseNumber, questionTitle, suggestedAnswer) {
		this.exerciseNumber = exerciseNumber;
		this.questionTitle = questionTitle;
		this.suggestedAnswer = suggestedAnswer;
		this.setAnswers(questionId);
		this.showAnswersOverlayBox = !this.showAnswersOverlayBox;

		//prevent body scroll
		document.querySelector('body').style.overflowY = "hidden";
	}

	directlyPostUserAnswerInput($event) {
		let question = $event.currentTarget.closest('.' + this.questionCssClassPrefix + 'question-container');
		let loader = question.querySelector('.answer-loader');
		let loader2 = question.querySelector('.answer-loader2')

		try {

			let self = this;
			let answerData = {
				userId: '',
				questionId: '',
				answer: '',
			}

			let studentId = this.route.snapshot.paramMap.get('studentId');
			if (!studentId || studentId == '') {
				answerData['userId'] = this.currentUser['id'];
			} else {
				answerData['userId'] = studentId;
			}

			if (self.isPreview() == true) {
				return false;
			}

			let questionId = question.getAttribute('data-question-id');
			let answer = question.querySelector('.' + this.questionCssClassPrefix + 'text-answer').value;

			var answerLength = answerData['content'];

			this.showAnswerLoader(loader, loader2, answerLength);

			answerData['questionId'] = questionId;
			answerData['answer'] = answer;

			self.apiConnectionService.save('users/answer', answer).then((response) => {
				self.changeStatusAnswerLoader(loader2);
				// self.hideAnswerLoader(loader2);
			}).catch(function (err) {
				self.hideAnswerLoader(loader2);
			});

		} catch (err) {
			this.hideAnswerLoader(loader2);
		}
	}

	isMultipleChoiceAnswer(str) {
		if (str.length == 1 && (/[A-J]/.test(str) || /[0-6]/.test(str))) {
			return true;
		} else {
			return false
		}
	}

	showAnswerLoader(loader, loader2, answer) {
		try {
			if (answer.length > 3 && loader != null) {
				loader.style.display = 'none';
			}
			if (answer.length < 4 && this.isMultipleChoiceAnswer(answer) == false) {
				loader.querySelector('.answer-loader-text').textContent = 'Weet je zeker dat dit je antwoord is?';
				loader.classList.remove("errColor");
				loader.style.display = 'flex';
			}
			loader2.querySelector('.answer-loader-text2').textContent = 'Bezig met opslaan...';
			loader2.querySelector('.answer-loader-icon2').classList.add('fa-circle-notch', 'fa-spin');
			loader2.style.opacity = '1';
		} catch (e) {

		}
	}

	showErrorPopup(container, str) {
		const text = container.querySelector('.answer-loader-text');

		let refreshButton = document.createElement("a");
		refreshButton.text = "Vernieuw de pagina";
		refreshButton.addEventListener('click', function () {
			window.location.reload();
		});

		text.textContent = str;
		container.style.display = 'flex';
		container.classList.add("errColor");

		text.appendChild(refreshButton);
	}

	changeStatusAnswerLoader(loader) {
		loader.querySelector('.answer-loader-text2').textContent = 'Opgeslagen!';
		loader.querySelector('.answer-loader-icon2').classList.remove('fa-circle-notch', 'fa-spin');
		loader.querySelector('.answer-loader-icon2').classList.add('fa-check');
	}

	hideAnswerLoader(loader) {
		setTimeout(function () {
			try {
				loader.style.opacity = '0';
				loader.querySelector('.answer-loader-icon2').classList.remove('fa-check');
			} catch (e) {

			}
		}, 4000);
	}

	addAnswerSubmitButtons() {
		try {
			let self = this;
			let questionContainers = this.elementRef.nativeElement.querySelectorAll('.' + this.questionCssClassPrefix + 'question-container' + ' .answer-buttons');

			if (questionContainers != null) {

				for (let i = 0; i < questionContainers.length; i++) {

					// button
					let button = document.createElement('a');
					button.append('Verzend antwoord');

					button.addEventListener('click', function ($event) {
						self.directlyPostUserAnswerInput($event);
					});
					button.setAttribute('href', 'javascript:void(0)');
					button.setAttribute('class', 'answer-submit-button btn btn-tertiary shadow-sm');
					button.setAttribute('style', 'display: none !important; font-size: .8rem; border:none; text-decoration: none; margin-right: 1rem;');

					// loader
					let loader = document.createElement('div');
					let loader2 = document.createElement('div');

					// row
					let row = document.createElement('div');
					row.setAttribute('class', 'answerStatusBar')

					loader.setAttribute('class', 'answer-loader bg-warning');
					loader.style.display = 'none';

					loader2.setAttribute('class', 'answer-loader2');
					loader2.style.opacity = '0';

					let loaderText = document.createElement('span');
					loaderText.setAttribute('class', 'answer-loader-text');
					loaderText.setAttribute('style', 'padding-right: .5rem;');

					let loaderIcon = document.createElement('i');
					loaderIcon.setAttribute('class', 'answer-loader-icon fas');

					let loaderText2 = document.createElement('span');
					loaderText2.setAttribute('class', 'answer-loader-text2');
					loaderText2.setAttribute('style', 'padding-right: .5rem;');

					let loaderIcon2 = document.createElement('i');
					loaderIcon2.setAttribute('class', 'answer-loader-icon2 fas');

					loader.append(loaderText);
					loader.append(loaderIcon);

					loader2.append(loaderText2);
					loader2.append(loaderIcon2);

					row.append(button);
					row.append(loader);

					questionContainers[i].append(loader2);

					questionContainers[i].append(row);
				}
			}

		} catch (err) {
		}

	}

	addShowStudentAnswersButtons() {
		if (this.currentUser['role'] === 'TEACHER' || this.currentUser['role'] === 'ADMIN') {
			try {
				let self = this;
				let questionContainers = this.elementRef.nativeElement.querySelectorAll('.' + this.questionCssClassPrefix + 'question-container');

				if (questionContainers != null) {
					for (let i = 0; i < questionContainers.length; i++) {
						let dataBlockId = questionContainers[i].getAttribute('data-block-id');
						let dataQuestionId = questionContainers[i].getAttribute('data-question-id');
						let eyeBtn = self.elementRef.nativeElement.querySelector('.' + this.questionCssClassPrefix + 'answer-toggle-show[data-target-id="' + dataQuestionId + '"]');

						let exerciseNumber = self.elementRef.nativeElement.querySelector('#' + this.questionCssClassPrefix + 'question-title-' + dataBlockId).textContent;
						let questionTitle = self.elementRef.nativeElement.querySelector('#' + this.questionCssClassPrefix + 'question-' + dataQuestionId + '').innerHTML;

						let suggestedAnswer = self.elementRef.nativeElement.querySelector('#' + this.questionCssClassPrefix + 'answer-' + dataQuestionId);
						suggestedAnswer = suggestedAnswer != null ? suggestedAnswer.textContent : '';

						questionContainers[i].style.position = 'relative';
					}
				}

			} catch (err) {
			}
		}
	}

	setAnswers(questionId) {
		let self = this;
		this.ngxLoader.start();
		self.apiConnectionService.read('answers/classroom/' + this.currentClassroom['id'] + '/' + questionId).then(function (response) {
			self.answers = response;
			self.ngxLoader.stop();

			//start checking which students have yet to complete the question
			self.getMissingStudents(response);
		}).catch(function (err) {
		});
	}

	getMissingStudents(answers) {
		let self = this;

		let participatedStudents = [];
		self.missingStudents = [];

		answers.forEach(function (answer) {
			participatedStudents.push(answer.userId);
		});

		this.students.forEach(function (student) {
			if (!participatedStudents.includes(student.id)) {
				self.missingStudents.push({ "id": student.id, "name": student.name });
			}
		});
	}

	showAnswerTextContainers() {
		let self = this;
		setTimeout(function () {
			self.addAnswerSubmitButtons();
			self.showAnswerContainers = true;
			if (!self.currentStudentId &&
				(
					self.currentUser['role'] === 'TEACHER' ||
					self.currentUser['role'] === 'EDITOR' ||
					self.currentUser['role'] === 'ADMIN')
			) {
				self.showAnswerContainers = false;
			}
			else {
				self.showAnswerContainers = true;
			}
		}, 1500);
	}

	showAnswerTextContainersForStudents() {
		if (
			(this.currentUser['role'] === 'STUDENT' && this.currentUser['hasEnabledAnswerClassrooms'] == true)
			|| (this.currentUser['role'] === 'TEACHER' || this.currentUser['role'] === 'ADMIN' && this.currentUser['hasEnabledAnswerClassrooms'] == true)
		) {
			this.showAnswerTextContainers();
		}
	}

	updateAnswerState(state, answer) {
		let currentState = answer['state'].toLowerCase();

		if (state === 'perfect') {
			if (currentState === 'perfect') {
				answer['state'] = ' ';
			} else {
				answer['state'] = "PERFECT";
			}
		} else if (state === 'correct') {
			if (currentState === 'correct') {
				answer['state'] = ' ';
			} else {
				answer['state'] = "CORRECT";
			}
		} else if (state === 'wrong') {
			if (currentState === 'wrong') {
				answer['state'] = ' ';
			} else {
				answer['state'] = "WRONG";
			}
		}

		let self = this;
		answer['questionStatus'] = answer['state'];

		if (this.currentStudentId == answer['userId']) {
			try {
				let parentButtonElement = self.elementRef.nativeElement.querySelector('textarea[data-question-id="' + answer['questionId'] + '"]').parentElement;
				parentButtonElement.querySelectorAll('button[data-value="' + answer['state'] + '"]')[0].click();
			} catch (e) { }
		}
		else {
			self.apiConnectionService.save('users/answer/status', answer).then((response) => {

			}).catch(function (err) {
			});
		}
	}

	closeMenus($event) {
		if ($event.target.closest('.anchor-dropdown-lessons') == null) {
			this.showLessonList = false;
		}
		if ($event.target.closest('.anchor-dropdown-classroom-student') == null) {
			this.showOptionsMenu = false;
		}
	}

	setStudyLevels() {
		this.studyLevels = this.configService.get('study_levels');
	}

	setCurrentStudyLevel(studyLevel) {
		this.showOptionsMenu = false;
		this.apiConnectionService.read('users/changeStudyLevel/' + studyLevel + '').then(function (response) {
			window.location.reload();
		});
	}

	setQuestionsWithAnswers(lessonId, classroomId) {
		let self = this;
		return;
		this.apiConnectionService.read('answers/overview/' + lessonId + '/' + classroomId).then(function (response) {
			self.questionsWithAnswers = response;
			self.showCheckStudentAnswerButtons();
		}).catch(function (err) {
		});
	}

	async showCheckStudentAnswerButtons() {
		let checkAnswerButtons = this.elementRef.nativeElement.querySelectorAll('.check-answers-button');

		for (let i = 0; i < checkAnswerButtons.length; i++) {
			let questionId = checkAnswerButtons[i].closest('[data-question-id]').getAttribute('data-question-id');
			this.questionIds.push(questionId);

			checkAnswerButtons[i].style.display = 'inline-block';
		}
	}

	toggleSuggestedAnswerInModal() {
		this.showSuggestedAnswerInModal = !this.showSuggestedAnswerInModal;
	}

	setHideStudentAnserNames() {
		this.showStudentAnswerNames = false;
	}

	setShowStudentAnserNames() {
		this.showStudentAnswerNames = true;
	}

	toggleShowNames() {
		this.showStudentAnswerNames = !this.showStudentAnswerNames;
	}

	navigateToQuestionInModal(direction) {
		/*
			Stap 1: haal de positie op van de huidige vraag uit de array van vragen met antwoorden
			Stap 2: pak de id van de vorige/volgende vraag uit de array o.b.v. de positie uit stap 1
			Stap 3: update de data
		 */
		let arr = this.objKeys(this.questionsWithAnswers)
		this.currentQuestionPosition = arr.indexOf(this.currentQuestionId);

		if (this.currentQuestionPosition != null && this.currentQuestionPosition !== -1) {

			if (direction === 'prev') {
				if (this.currentQuestionPosition > 0) {
					this.currentQuestionPosition -= 1;
				}
			} else if (direction === 'next') {
				if (this.currentQuestionPosition >= 0 && this.currentQuestionPosition < arr.length) {
					this.currentQuestionPosition += 1;
				}
			}

			let id = arr[this.currentQuestionPosition];

			if (id != null) {
				this.currentQuestionId = id;
				this.setAnswers(id);
				this.questionTitle = this.elementRef.nativeElement.querySelector('#' + this.questionCssClassPrefix + 'question-' + id).textContent;
				this.suggestedAnswer = this.elementRef.nativeElement.querySelector('#' + this.questionCssClassPrefix + 'answer-' + id).textContent;
				let blockId = id.split('-')[0];
				this.exerciseNumber = this.elementRef.nativeElement.querySelector('#' + this.questionCssClassPrefix + 'question-title-' + blockId).textContent;
			}
		}
	}
}
